export const SORT_OPTIONS = {
  RELEVANCE: {
    value: "relevance",
    label: "Relevance",
  },
  FEATURED: {
    value: "featured",
    label: "Featured",
  },
  NEWEST: {
    value: "newest",
    label: "Newest",
  },
  BEST_SELLING: {
    value: "bestselling",
    label: "Top Sellers",
  },
  ALPHA_ASC: {
    value: "alphaasc",
    label: "A - Z",
  },
  ALPHA_DESC: {
    value: "alphadesc",
    label: "Z - A",
  },
  REVIEWS: {
    value: "avgcustomerreview",
    label: "Reviews",
  },
};